import * as bip39 from 'bip39';
import CryptoJS from 'crypto-js';
import { getPublicKey } from 'nostr-tools/pure';

/**
 * Seed Phrase (BIP39) and Encryption Manager
 */
export const seedPhraseManager = {
    /**
     * Generate a new 12-word seed phrase
     */
    generateMnemonic(): string {
        return bip39.generateMnemonic(128); // 128 bits = 12 words
    },

    /**
     * Validate a seed phrase
     */
    validateMnemonic(mnemonic: string): boolean {
        return bip39.validateMnemonic(mnemonic.trim().toLowerCase());
    },

    /**
     * Derive technical secret key (32 bytes) from mnemonic
     */
    deriveSecretKey(mnemonic: string): Uint8Array {
        const seed = bip39.mnemonicToSeedSync(mnemonic.trim().toLowerCase());
        return new Uint8Array(seed.slice(0, 32));
    },

    /**
     * Encrypt mnemonic with a user-provided password for local storage
     */
    encryptMnemonic(mnemonic: string, password: string): string {
        return CryptoJS.AES.encrypt(mnemonic.trim(), password).toString();
    },

    /**
     * Decrypt mnemonic from local storage using password
     */
    decryptMnemonic(encrypted: string, password: string): string | null {
        try {
            const bytes = CryptoJS.AES.decrypt(encrypted, password);
            const decrypted = bytes.toString(CryptoJS.enc.Utf8);
            return decrypted || null;
        } catch (error) {
            console.error('[SeedManager] Decryption failed:', error);
            return null;
        }
    },

    /**
     * Get public key from mnemonic
     */
    getPubkeyFromMnemonic(mnemonic: string): string {
        const sk = this.deriveSecretKey(mnemonic);
        return getPublicKey(sk);
    }
};
